import { NgClass } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { tap } from 'rxjs';

import { propertyTypes } from '@alan-apps/api-interfaces';
import {
  ControlContainerProvider,
  useI18nRouter,
} from '@nghedgehog/angular-ui';
import { useTakeUntilDestroyed } from '@nghedgehog/core';
import { TranslateModule } from '@ngx-translate/core';

import { PropertyService } from '../../../service/property.service';
import { input } from '@angular/core';

@Component({
  selector: 'app-search-type-nav',
  templateUrl: './search-type-nav.component.html',
  styleUrls: ['./search-type-nav.component.scss'],
  viewProviders: [ControlContainerProvider],
  standalone: true,
  imports: [NgClass, TranslateModule],
})
export class SearchTypeNavComponent implements OnInit {
  private _property = inject(PropertyService);
  public controlContainer = inject(ControlContainer);
  private _route = inject(ActivatedRoute);
  readonly takeUntilAppDestroy = useTakeUntilDestroyed();

  noInit = input(false);
  showTypes = input<number[]>([]);
  classList = input('mb-4');

  types: typeof this._property.types;

  get classification() {
    return this.controlContainer.control.get('classification');
  }
  private _router = useI18nRouter();

  ngOnInit(): void {
    this.types =
      this.showTypes().length > 0
        ? this._property.types.filter((x) =>
            this.showTypes().some((y) => y === +x.id),
          )
        : this._property.types;

    this._route.queryParams
      .pipe(
        tap((x) => {
          // check init classification
          const classification =
            this._route.snapshot.queryParamMap.get('classification');
          if (classification !== null) {
            return this.classification.patchValue(classification, {
              emitEvent: false,
            });
          }

          if (this.noInit()) {
            return;
          }
          this.classification.patchValue(this.types[0].id, {
            emitEvent: false,
          });
        }),
        this.takeUntilAppDestroy(),
      )
      .subscribe();
  }

  setValue(typeItem: Pick<(typeof propertyTypes)[number], 'id' | 'url'>) {
    if (typeItem.url) {
      this._router.navigate([typeItem.url]);
      return;
    }
    if (this.classification.value !== typeItem.id) {
      this.classification.patchValue(typeItem.id);
    }
  }
}
